// lib/analytics.js
import axios from "axios";
import config from "../../src/config/config";

function generateUUID() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
export function getVisitorId() {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id = generateUUID();
    localStorage.setItem("visitor_id", id);
  }
  return id;
}
export function getSessionId() {
  const MAX_INACTIVE_TIME = 30 * 60 * 1000;
  let sessionId = sessionStorage.getItem("session_id");
  let lastActivity = sessionStorage.getItem("last_activity");
  const now = Date.now();

  if (!sessionId || !lastActivity || now - lastActivity > MAX_INACTIVE_TIME) {
    sessionId = generateUUID();
    sessionStorage.setItem("session_id", sessionId);
  }

  sessionStorage.setItem("last_activity", now);
  return sessionId;
}

export const logUserAction = async (actionObject) => {
  const payload = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    data: {
      ...actionObject,
    },
  };
  try {
    await axios.post(`${config.backendUrl}/analytics/writeLog`, payload);
  } catch (error) {
    console.error("Log writing failed:", error);
  }
};

export const logBatchUserAction = async (actionsArray) => {
  if (!actionsArray || actionsArray.length === 0) return;
  
  const visitor_id = getVisitorId();
  const session_id = getSessionId();
  
  const payload = actionsArray.map(actionObject => ({
    visitor_id,
    session_id,
    data: {
      ...actionObject,
    },
  }));
  
  try {
    await axios.post(`${config.backendUrl}/analytics/log-batch`, payload);
  } catch (error) {
    console.error("Batch log writing failed:", error);
  }
};

export const createSearchFeedback = async (feedback, reason) => {
  let sessionId = getSessionId();
  let visitorId = getVisitorId();
  const anaylyticsId = await axios.get(
    `${config.backendUrl}/analytics/getAnalyticsId?visitor_id=${visitorId}&session_id=${sessionId}`,
  );
  const payload = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    anyalytics_id: anaylyticsId.data.analytics_id,
    feedback: feedback || "up",
    reason: reason,
  };
  try {
    await axios.post(`${config.backendUrl}/searchfeedback/create`, payload);
  } catch (error) {
    console.error("Log writing failed:", error);
  }
};
